// Turns any thrown submit error into a client-friendly, localized message.
//
// Users must never see axios's raw "Request failed with status code 400" or
// "Network Error". Priority (for Axios errors):
//   1. The backend's own {message} - our business errors are already human
//      text (e.g. "This station is already booked for the selected period.").
//   2. No response at all → a network/timeout message.
//   3. 400/422 (model validation) → a "check your input" message.
//   4. Anything else (incl. non-Axios exceptions, e.g. a bug in our own code)
//      → a caller-supplied fallback, else a generic message.
import axios from 'axios';
import { t } from './i18n/i18n';

export function friendlyError(err: unknown, genericFallback?: string): string {
  if (axios.isAxiosError(err)) {
    const resp = err.response;
    const serverMsg = (resp?.data as { message?: string } | undefined)?.message;
    if (typeof serverMsg === 'string' && serverMsg.trim()) return serverMsg;
    // Only a genuine Axios request with no response is a network/timeout.
    if (!resp) return t('common.errors.network');
    if (resp.status === 400 || resp.status === 422) return t('common.errors.invalid');
  }
  return genericFallback ?? t('common.errors.generic');
}
